import { AppConfig, KioskSessionConfig } from "@/shared/types/config";

export const DEFAULT_KIOSK_SESSION_CONFIG: KioskSessionConfig = {
  idlePromptAfterMs: 90_000,
  idleTimeoutMs: 120_000,
};

const normalizeKioskSessionConfig = (
  kioskSession?: Partial<KioskSessionConfig>,
): KioskSessionConfig => {
  const idlePromptAfterMs = Number(kioskSession?.idlePromptAfterMs);
  const idleTimeoutMs = Number(kioskSession?.idleTimeoutMs);
  const hasValidTiming =
    Number.isInteger(idlePromptAfterMs) &&
    Number.isInteger(idleTimeoutMs) &&
    idlePromptAfterMs > 0 &&
    idleTimeoutMs > idlePromptAfterMs;

  if (!hasValidTiming) {
    return { ...DEFAULT_KIOSK_SESSION_CONFIG };
  }

  return {
    idlePromptAfterMs,
    idleTimeoutMs,
  };
};

let config: AppConfig | null = null;
const configs = import.meta.glob<AppConfig>("./*", {
  eager: true,
  import: "default",
});
let mode = import.meta.env.MODE; // Set Vite mode as default

// Take dev-cloud stage/qa config
if (import.meta.env.PROD && import.meta.env.VITE_PROJECT_ID.includes("dev")) {
  mode = "qa";
}

if (import.meta.env.PROD && import.meta.env.VITE_PROJECT_ID.includes("stage")) {
  mode = "stage";
}
if (import.meta.env.PROD && import.meta.env.VITE_PROJECT_ID.includes("demos")) {
  mode = "demos";
}
const rawConfig = configs[`./${mode}.config.json`] as AppConfig | undefined;

config = rawConfig
  ? {
      ...rawConfig,
      kioskSession: normalizeKioskSessionConfig(rawConfig.kioskSession),
    }
  : null;

export default config;
